<template>
	<div id="zexian-app">
		<div id="zexian-main" :style="{'min-width':minWidth}"></div>
	</div>
</template>
<script>
	let myChart
	export default {
		name: "zexian-app",
		data(){
			return {
				width:'500px',
			}
		},
		props:['data1','data2','date','minWidth'],
		methods: {
			drawChart() {
				let _this=this
				console.log(_this.data2)
				// 基于准备好的dom，初始化echarts实例
				 myChart = this.$echarts.init(document.getElementById("zexian-main"));
				// 指定图表的配置项和数据
				 let option = {
					title: {
						//text: '折线图堆叠'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: _this.data1
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: true,
						data: _this.date
					},
					yAxis: {
						type: 'value'
					},
					series:_this.data2
				}; 
				
				

				console.log(option)
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
				
			}
		},
		beforeDestroy () {
		    myChart.clear()
		},
		mounted() {
			console.log(this.minWidth)
			if(this.minWidth==null || this.minWidth=='' || this.minWidth==undefined){
				this.width="1000px"
			}else{
				this.width=this.minWidth
			}
			
			this.drawChart();
		}
	};
</script>
<style scoped="scoped">
	#zexian-main{
		border: 1px solid #092537;
		/* min-width: 500px; */
		
		min-height: 400px;
		height: 400px;
	}
</style>


// WEBPACK FOOTER //
// src/components/comm/home/zexiantu.vue